export default function(x) {
  return (0.05859375 * x * x * (1 + 0.75 * x));
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/e2fn.js
// module id = 37
// module chunks = 0 1